import { PROFILE } from "@src/helpers/imagesConstants";
import { getSubject } from "@src/redux/index";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CiMobile3 } from "react-icons/ci";
import { IoIosInformationCircle } from "react-icons/io";
import { MdOutlineBloodtype } from "react-icons/md";
import { TbGenderBigender } from "react-icons/tb";
import { Tooltip } from "antd";
import { useSelector } from "react-redux";
import { startCase } from "lodash";
import moment from "moment";
import { bloodGroupObject, getAgeCalculate } from "@src/helpers/constants";

type Props = {};

const MobileSubjectUserDetails = (props: Props) => {
  const { result: subject } = useSelector(getSubject);
  const { t } = useTranslation();

  

  const tooltipContent = (
    <div className="tooltip_container">
      <p>{subject?.name || "-"}</p>
      <hr />
      <p>
        <strong className="subject_details_mobile_tooltip_label">
          {t("dob")}:{" "}
        </strong>
        {moment(subject?.dob).format("DD-MMM-YYYY") || t("-")}
      </p>
      <p>
        <strong className="subject_details_mobile_tooltip_label">
          {t("email")}:{" "}
        </strong>{" "}
        {subject?.email || "-"}
      </p>
      <p>
        <strong className="subject_details_mobile_tooltip_label">
          {t("address")}:{" "}
        </strong>{" "}
        {subject?.address || "-"}
      </p>
      <p>
        <strong className="subject_details_mobile_tooltip_label">
          {t("height")}:{" "}
        </strong>{" "}
        {startCase(subject?.gender) || "-"}
      </p>
      <p>
        <strong className="subject_details_mobile_tooltip_label">
          {t("weight")}:{" "}
        </strong>
        {subject?.subjectMetric?.weight || "-"}
      </p>

      <p>
        <strong className="subject_details_mobile_tooltip_label">
          {t("bmi")}:{" "}
        </strong>
        {Number(subject?.subjectMetric?.bmi).toFixed(2).toString() || "-"}
      </p>
      <p>
        <strong className="subject_details_mobile_tooltip_label">
          {t("bsa")}:{" "}
        </strong>
        {Number(subject?.subjectMetric?.bsa).toFixed(2).toString() || "-"}
      </p>

      <p>
        <strong className="subject_details_mobile_tooltip_label">
          {t("smoker")}:{" "}
        </strong>
        {startCase(String(subject?.subjectMetric?.isSmoker)) || "-"}
      </p>
      <p>
        <strong className="subject_details_mobile_tooltip_label">
          {t("diabetic")}:{" "}
        </strong>
        {startCase(String(subject?.subjectMetric?.isDiabetic)) || "-"}
      </p>
      <p>
        <strong className="subject_details_mobile_tooltip_label">
          {t("hypertensive")}:{" "}
        </strong>
        {startCase(String(subject?.subjectMetric?.isHypertensive)) || "-"}
      </p>
    </div>
  );

  return (
    <div className="subject_mobile_details_container">
      <div className="subject_profile_container">
        <img src={PROFILE} className="subject_profile_image" />
      </div>
      <div className="subject_mobile_profile_details_container">
        <div className="subject_profile_details_first_row">
          <span className="subject_mobile_name">
            {startCase(subject?.name)}
          </span>
          <div className="subject_mobile_info">
            <Tooltip
              title={tooltipContent}
              style={{ marginRight: "30px", zIndex: "4000" }}
              placement="bottomRight"
              className="subject_details_mobile_tooltip"
            >
              <IoIosInformationCircle />
            </Tooltip>
          </div>
        </div>
        <div className="subject_profile_details_second_row">
          <div className="subject_mobile_ref_id_container">
            <span className="subject_mobile_ref_id">
              {startCase(
                subject?.keyValueList?.[0]?.organizationSubjectKey?.name
              )}
            </span>
            <span className="subject_mobile_ref_id_value">
              {subject?.keyValueList?.[0]?.value}
            </span>
          </div>

          <span className="subject_mobile_type">
            <span className="subject_mobile_ref_id">{t("type")}</span>
            <span className="subject_mobile_ref_id_value">
              {startCase(subject?.subjectType)}
            </span>
          </span>
          <span className="subject_mobile_age">
            <span className="subject_mobile_ref_id">{t("age")}</span>
            <span className="subject_mobile_ref_id_value">
              {getAgeCalculate(subject?.dob?.toString() || "")}
            </span>
          </span>
        </div>
        <div className="subject_profile_details_third_row">
          <div className="subject_mobile_gender">
            <span className="subject_mobile_gender_id">
              <TbGenderBigender />
            </span>
            <span className="subject_mobile_ref_id_value">
              {startCase(subject?.gender)}
            </span>
          </div>

          <div className="subject_mobile_blood_group">
            <div className="subject_mobile_gender_id">
              <MdOutlineBloodtype />
            </div>
            <span className="subject_mobile_ref_id_value">
              {bloodGroupObject[subject?.bloodGroup || ""]}
            </span>
          </div>

          <div className="subject_mobile_mobile_number">
            <div className="subject_mobile_gender_id">
              <CiMobile3 />
            </div>
            <span className="subject_mobile_ref_id_value">
            {subject?.mobile?.CountryCode}  {subject?.mobile?.Number}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileSubjectUserDetails;
